import React from 'react';
import { FAB } from 'react-native-paper';
import { t } from '@lingui/macro';
import { useNavigation } from '@react-navigation/native';
import styled from 'styled-components/native';

import FontIcon from '@src/components/FontIcon';
import ImageIcon from '@src/components/ImageIcon';
import { i18n } from '@src/i18n';

const FabGroup = styled(FAB.Group).attrs(({ theme }) => ({
  visible: true,
  color: theme.colors.onPrimary,
  fabStyle: {
    backgroundColor: theme.colors.primary,
  },
}))``;

const Times = styled(FontIcon).attrs({
  name: 'times',
})`
  align-self: center;
`;

const Plus = styled(FontIcon).attrs({
  name: 'plus',
})`
  align-self: center;
`;

const Component: React.FC = () => {
  const navigation = useNavigation();
  const [open, setOpen] = React.useState(false);
  const handleStateChange = React.useCallback(
    (state: { open: boolean }) => setOpen(state.open),
    []
  );
  const handleNewJourneyPress = React.useCallback(
    () => navigation.navigate('Dummy'),
    [navigation]
  );
  const handleNewPostPress = React.useCallback(
    () => navigation.navigate('NewPost'),
    [navigation]
  );

  return (
    <FabGroup
      open={open}
      icon={
        open ? (props) => <Times {...props} /> : (props) => <Plus {...props} />
      }
      actions={[
        {
          icon: (props) => (
            <ImageIcon
              source={require('@src/assets/images/journey.png')}
              {...props}
            />
          ),
          label: i18n._(t`New Journey`),
          onPress: handleNewJourneyPress,
        },
        {
          icon: (props) => (
            <ImageIcon
              source={require('@src/assets/images/newPost.png')}
              {...props}
            />
          ),
          label: i18n._(t`New Post`),
          onPress: handleNewPostPress,
        },
      ]}
      onStateChange={handleStateChange}
    />
  );
};

Component.displayName = 'NewEntryFab';

export default React.memo(Component);
